import { PlusOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { OntologyValueType } from 'features/dynamicOntology'
import { FC } from 'react'

import { PropertyType, PropertyTypeSelect } from './PropertyTypeSelect'

const ADD_PROPERTY_ALLOWED_TYPES: ReadonlyArray<PropertyType> = [
  'text',
  'number',
  'boolean',
  'enum',
  'date',
  'object',
  'array',
]

export const getInitialValueForType = (
  type: PropertyType
): OntologyValueType => {
  switch (type) {
    case 'number':
      return 0
    case 'boolean':
      return false
    case 'object':
      return {}
    case 'array':
      return []
    case 'enum':
      return ''
    case 'date':
      return dayjs().format('YYYY-MM-DD')
    case 'text':
    default:
      return ''
  }
}

interface AddPropertyButtonProps {
  onAddProperty: (type: PropertyType) => void
  allowedTypes?: ReadonlyArray<PropertyType>
}

export const AddPropertyButton: FC<AddPropertyButtonProps> = ({
  onAddProperty,
  allowedTypes,
}) => {
  return (
    <PropertyTypeSelect
      setSelectedType={onAddProperty}
      allowedTypes={allowedTypes ?? ADD_PROPERTY_ALLOWED_TYPES}
      overrideButtonIcon={<PlusOutlined />}
    />
  )
}
